/**
 * @flow
 * @relayHash 9e6bdbc220669fd36ece5c78d28e0587
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
export type ConfigurableBlockAddInput = {
  type: ConfigurableBlockType,
  slug?: ?string,
  active?: ?boolean,
  config?: ?any,
  clientMutationId?: ?string,
};
export type ConfigurableBlockAddMutationVariables = {|
  input: ConfigurableBlockAddInput
|};
export type ConfigurableBlockAddMutationResponse = {|
  +ConfigurableBlockAdd: ?{|
    +error: ?string,
    +edge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type ConfigurableBlockAddMutation = {|
  variables: ConfigurableBlockAddMutationVariables,
  response: ConfigurableBlockAddMutationResponse,
|};
*/


/*
mutation ConfigurableBlockAddMutation(
  $input: ConfigurableBlockAddInput!
) {
  ConfigurableBlockAdd(input: $input) {
    error
    edge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfigurableBlockAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ConfigurableBlockAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ConfigurableBlockAddInput!"
      }
    ],
    "concreteType": "ConfigurableBlockAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edge",
        "storageKey": null,
        "args": null,
        "concreteType": "ConfigurableBlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ConfigurableBlockAddMutation",
  "id": null,
  "text": "mutation ConfigurableBlockAddMutation(\n  $input: ConfigurableBlockAddInput!\n) {\n  ConfigurableBlockAdd(input: $input) {\n    error\n    edge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ConfigurableBlockAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfigurableBlockAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c33da50925c5517dd7dbcc166c958cda';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/__generated__/ConfigurableBlockAddMutation.graphql.js